import dayjs from 'dayjs';

import type { ChartPeriod } from '../performance-types';

export function calculateDateRangeFromBar(
  dateLabel: string,
  period: ChartPeriod,
): { startDate: Date; endDate: Date } {
  // Get current year for daily/weekly where year is not in the label
  const currentYear = dayjs().year();

  switch (period) {
    case 'daily': {
      // For daily, the label is "MMM DD" (e.g., "Jan 01")
      // Need to add the year since it's not in the label
      const date = dayjs(`${dateLabel} ${currentYear}`, 'MMM DD YYYY');
      return {
        startDate: date.startOf('day').toDate(),
        endDate: date.endOf('day').toDate(),
      };
    }
    case 'weekly': {
      // For weekly, the label is "MMM DD" representing the start of the week
      const weekStart = dayjs(`${dateLabel} ${currentYear}`, 'MMM DD YYYY');
      const weekEnd = weekStart.add(6, 'day');
      return {
        startDate: weekStart.startOf('day').toDate(),
        endDate: weekEnd.endOf('day').toDate(),
      };
    }
    case 'monthly': {
      // For monthly, the label is "MMM YYYY" (e.g., "Jan 2024")
      const date = dayjs(dateLabel, 'MMM YYYY');
      return {
        startDate: date.startOf('month').toDate(),
        endDate: date.endOf('month').toDate(),
      };
    }
    default:
      throw new Error(`Unsupported period: ${period}`);
  }
}
